import { render, staticRenderFns } from "./DNZYPrintModel.vue?vue&type=template&id=fa8e450e&scoped=true"
import script from "./DNZYPrintModel.vue?vue&type=script&lang=js"
export * from "./DNZYPrintModel.vue?vue&type=script&lang=js"
import style0 from "./DNZYPrintModel.vue?vue&type=style&index=0&id=fa8e450e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8e450e",
  null
  
)

export default component.exports